import '../App.css';
import { ethers } from 'ethers';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import NFTCollection from './NFTCollection.json';
import { Card, Container, Text, Grid, Spacer, Image } from '@nextui-org/react';
import { key, displayAmount, mainnet } from './settings';
import { useAccount } from 'wagmi';

export default function NftPuller(props) {

  const [loadingState, setLoadingState] = useState('not-loaded')
  const [nfts, setNfts] = useState([])
  const { address } = useAccount();

  var myCont = "";
  var myCount = "";
  
  if (props.selCont === "msb") {
    var myCont = "0x9e02C26CDBB3040e8CAb59604DEa8B6118EB643e";
    var myCount = 200;
    var myUrl = "https://memescan.io/address/0x9e02C26CDBB3040e8CAb59604DEa8B6118EB643e";
  } 

  if (props.selCont === "mbe") {
    var myCont = "0x87a8A1c2193102fCFF25Ed0A7dfe0Cc13005b3EA";
    var myCount = 340;
    var myUrl = "https://memescan.io/address/0x87a8A1c2193102fCFF25Ed0A7dfe0Cc13005b3EA";
  }
  
    useEffect(() => {
      generateNft();
    }, [setNfts])

      async function generateNft() {
      const provider = new ethers.providers.JsonRpcProvider(mainnet)
      const wallet = new ethers.Wallet(key, provider);
      const contract = new ethers.Contract(myCont, NFTCollection, wallet);
      const itemArray = [];
      contract.totalSupply().then(result => {
        let totalSup = parseInt(result, 16)
        /*
        Replace "displayAmount" with "totalSup"
        below if you want to display all NFTs 
        in the collection BUT BE CAREFUL, it will render
        every nft image and possibly freeze your server/browser!!
        */
        for (let i = 0; i < myCount; i++) {
          var token = i + 1                         
          const owner = contract.ownerOf(token)
          const rawUri = contract.tokenURI(token)
          const Uri = Promise.resolve(rawUri)
          const getUri = Uri.then(value => {
            let str = value
            let cleanUri = str.replace('ipfs://', 'https://nftstorage.link/ipfs/')
            let metadata = axios.get(cleanUri).catch(function (error) {
              console.log(error.toJSON());
            });
            return metadata;
          })
          getUri.then(value => {
            let rawImg = value.data.image
            var name = value.data.name
            var desc = value.data.description
            var token = value.data.tokenId // not getting anything back for token id :C
            let image = rawImg.replace('ipfs://', 'https://nftstorage.link/ipfs/')
            Promise.resolve(owner).then(value => {
              let ownerW = value;
              let meta = {
                name: name,
                img: image,
                tokenId: token, // not getting any value back from JSON parse
                wallet: ownerW,
                desc,
              }
              if (ownerW === address) {
                itemArray.push(meta)
                console.log(meta)
              }
            })
          })
        }
      })
      await new Promise(r => setTimeout(r, 6000));
      setNfts(itemArray);
      setLoadingState('loaded');
    }

    if (loadingState === 'loaded' && !nfts.length)
      return (
        <div >
          <div>
            No Collections Retrieved
          </div>
        </div>
      ) 
      return ( 
        <Container md >
        <Grid.Container gap={3}>
          {nfts.map((nft, i) => {
            //if (nft.wallet === address)
              return (
                <Grid >
                  <Card isHoverable key={i} css={{ mw: "280px", marginRight: '$1', boxShadow:'0px 2px 12px #000000' }} variant="bordered">
                    <a href={nft.img} target="_blank" rel="noopener noreferrer" >
                      <Card.Image src={nft.img} />
                    </a>
                    <Card.Body md css={{background:"$gradient" }}>
                      <Text b css={{color:'$white'}} size={'22px'}>{nft.name}</Text>
                      <Text css={{color:'$white'}} size={'13px'}><b>Desc:</b><br />{nft.desc}</Text>
                      <Text css={{color:'$white'}} size={'10px'}><b>Owner:</b><br />{nft.wallet}</Text>
                    </Card.Body>
                  </Card>
                </Grid>
              )
            })}
        </Grid.Container>
        <br /><br /><br />
      </Container>
      ) 
    }
